import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router';
import favicon from 'shared/assets/images/favicon.png';
import faviconLarge from 'shared/assets/images/favicon-256.png';
import ogpLogo from 'shared/assets/images/ogp-logo.png';
import { urlToPublic } from 'shared/utils/helpers';

interface OwnProps {
  title: string;
}

type Props = OwnProps & RouteComponentProps<any>;

class BasicHead extends React.Component<Props> {
  render() {
    const { title } = this.props;
    const defaultOgpUrl = process.env.PUBLIC_HOST_URL + this.props.location.pathname;
    const defaultOgpImage = urlToPublic(ogpLogo);
    return (
      <Helmet>
        <title>{`ServiceBell - ${title}`}</title>
        <meta name="description" content={'description'} />
        <meta name="keywords" content="ServiceBell" />
        <link href={favicon} rel="shortcut icon" type="image/x-icon" />
        <link href={faviconLarge} rel="apple-touch-icon" />

        {/* open graph protocol defaults, can be overridden in children <HeaderDetails ...> */}
        <meta property="og:site_name" content="ServiceBell" />
        <meta property="og:title" content={`ServiceBell - ${title}`} />
        <meta property="og:description" content={'description'} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={defaultOgpUrl} />
        <meta property="og:image" content={defaultOgpImage} />
        <meta property="og:locale" content="en_US" />
        {/* <meta property="og:locale:alternate" content="en_US" /> */}
        {/* <meta property="og:locale:alternate" content="de_DE" /> */}

        {/* twitter defaults, can be overridden in children <HeaderDetails ...> */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:site" content="@stackinabox" />
        <meta property="twitter:title" content={`ServiceBell - ${title}`} />
        <meta property="twitter:description" content={'Description'} />
        <meta property="twitter:image" content={defaultOgpImage} />
        <meta property="twitter:url" content={defaultOgpUrl} />
      </Helmet>
    );
  }
}

export default withRouter(BasicHead);
